import { TabNav } from '@/components/TabNav';
import type { ConsiderationType } from '@rock/types';
import type { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppliesToDraftResultEntry } from './AppliesToDraftResultEntry';
import { AppliesToDraftResultsTable } from './AppliesToDraftResultsTable';
import { HomeEvalResultEntry } from './HomeEvalResultEntry';
import { HomeEvalResultsTable } from './HomeEvalResultsTable';

export const ConsiderationTypeResultsPage: FC<{ considerationType: ConsiderationType }> = ({ considerationType }) => {
    const typeId = considerationType.id;
    return (
        <div className="space-y-6">
            <div className="mb-4">
                <TabNav
                    tabs={[
                        {
                            label: 'Home Eval Results',
                            to: `/content/considerations/${typeId}/results/home-eval-results`,
                        },
                        { label: 'Query Drafts', to: `/content/considerations/${typeId}/results/query-drafts` },
                    ]}
                />
            </div>
            <Routes>
                <Route index element={<Navigate replace to="./home-eval-results" />} />
                <Route
                    path="home-eval-results"
                    element={<HomeEvalResultsTable considerationType={considerationType} />}
                />
                <Route
                    path="home-eval-results/:resultId"
                    element={<HomeEvalResultEntry considerationType={considerationType} />}
                />
                <Route
                    path="query-drafts"
                    element={<AppliesToDraftResultsTable considerationType={considerationType} />}
                />
                <Route
                    path="query-drafts/:resultId"
                    element={<AppliesToDraftResultEntry considerationType={considerationType} />}
                />
            </Routes>
        </div>
    );
};
